import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { throwError,Observable } from 'rxjs'
import { catchError,switchMap } from 'rxjs/operators'

import { AuthService } from '../services/auth.service';


@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private router: Router,private authService:AuthService) {}
  // https://medium.com/@monkov/angular-using-httpinterceptor-for-token-refreshing-3f04ea2ccb81
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
    if(localStorage.getItem("me")){
        // add authorization header with jwt token if available
        let me =  JSON.parse(localStorage.getItem("me"));
        let currentUser = me.token;//window.localStorage.getItem('token');
        let staySignIn =  me.stay_sign;
        let re1 =  "login";
        if (request.url.search(re1) === -1) {
          if (currentUser) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUser}`
                    }
                });
          }
        }
        
        
          return next.handle(request).pipe(catchError((err) => {
                if (err.status === 401) {
                
                  window.localStorage.removeItem('me');
                  
                  console.log("..error..."+err.error.error);
                  if (err.error.error == "Unauthorized") {
                    // if(staySignIn ==  true){
                    //   let param = {
                    //     username: JSON.parse(localStorage.getItem("me")).username,
                    //     password: JSON.parse(localStorage.getItem("me")).password
                    //   }
                    //   return this.authService.relogin(param).pipe(switchMap(resp=>{
                    //     console.log(resp);
                    //     if (resp.statusCode == 200) { //success
                    //       //Update tokens
                    //       resp.data["username"]=me.username;
                    //       resp.data["password"]=me.password;

                    //       localStorage.setItem("me",JSON.stringify(resp.data));

                    //       //Clone our fieled request ant try to resend it
                    //       request = request.clone({
                    //         setHeaders: {
                    //           Authorization: `Bearer ${resp.body.accessToken}`
                    //         }
                    //       });
                    //       return next.handle(request);
                    //     }else{
                        
                    //       localStorage.removeItem('me');
                    //       this.router.navigate(['/auth/login']);
                    //     }
                    //   }))
                    // }else{
                      console.log("keluar....");
                      localStorage.removeItem('me');
                      this.router.navigate(['/auth/login']);
                    // }

                  }else {
                    console.log("not ....Unauthorized")
                    // this.nativeStorage.clear();
                    // window.localStorage.removeItem('me');
                    // this.navCtrl.navigateRoot(['/signin']);
                      //Logout from account or do some other stuff
                  }
              }else if (err.status === 500) {
                localStorage.removeItem('me');
                this.router.navigate(['/auth/login']);
              }
                  
              return throwError(err);
              }))
          }else{
            return next.handle(request);
          }
    }
   

    
}